import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1120px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          为什么选择被窝影院
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          四大优势，打造最舒适的在线追剧体验
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200 p-5 text-center hover:border-primary-200 transition-all group cursor-pointer"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors mb-4">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}